import { Chip } from '@mui/material';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import Block from '@mui/icons-material/Block';
import { useTranslation } from 'react-i18next';

/**
 * C8: what a fired rule does — blocks (Error, the default) or asks (Warning). ONE chip for
 * the grid, the system-rule dialog, the system-rule page and the rule form, so an advisory
 * rule reads as an advisory everywhere it is shown, never as a red stop.
 */
export function RuleSeverityChip({ severity, size = 'small' }: { severity?: string | null; size?: 'small' | 'medium' }) {
  const { t } = useTranslation();
  const isWarning = (severity ?? '').toLowerCase() === 'warning';
  return isWarning ? (
    <Chip
      size={size}
      color="warning"
      icon={<WarningAmberRounded />}
      label={t('businessRules.severity.warning', { defaultValue: 'Warning' })}
    />
  ) : (
    <Chip
      size={size}
      color="error"
      variant="outlined"
      icon={<Block />}
      label={t('businessRules.severity.error', { defaultValue: 'Error' })}
    />
  );
}
